import { render } from "./ReportDanger.vue?vue&type=template&id=30d3026f"
import script from "./ReportDanger.vue?vue&type=script&lang=js"
export * from "./ReportDanger.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Reports/ReportDanger.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "30d3026f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('30d3026f', __exports__)) {
    console.log('reload')
    api.reload('30d3026f', __exports__)
  }
  
  module.hot.accept("./ReportDanger.vue?vue&type=template&id=30d3026f", () => {
    console.log('re-render')
    api.rerender('30d3026f', render)
  })

}


export default __exports__